import { Component, Input } from '@angular/core';
import { ActionDto, ActionModal, ModalService, WebAppCommonModule } from "@allbesmart/web-app-common";
import { WarningMessageModalActionConfig } from "../../models/action/warning-message-modal-action-config";

@Component({
    selector: 'oaibox-warning-message-action-modal',
    templateUrl: './warning-message-action-modal.component.html',
    styleUrls: ['./warning-message-action-modal.component.css'],
    imports: [WebAppCommonModule]
})
export class WarningMessageActionModalComponent implements ActionModal {

  @Input({required: true}) public actionConfig!: WarningMessageModalActionConfig;
  @Input({required: true}) public sendAction!: (actionDto: ActionDto) => void;

  constructor(private modalService: ModalService) {
  }

  public confirmAction(): void {
    this.modalService.popModal();
    this.sendAction({type: this.actionConfig.type, command: this.actionConfig.command});
  };

  protected discard(): void {
    this.modalService.popModal();
  }

}
